export const countries = [
  { value: "UY", label: "Uruguay", flag: "🇺🇾", phoneCode: "598" },
  { value: "AR", label: "Argentina", flag: "🇦🇷", phoneCode: "54" },
  { value: "BR", label: "Brasil", flag: "🇧🇷", phoneCode: "55" },
];
